import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityCard = ({ icon, iconColor, title, value, change, changeType }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className="card hover:shadow-xl transition-all duration-250">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name={icon} size={24} color={iconColor} />
            </div>
            <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
          </div>
          <div className="mt-4">
            <p className="text-3xl font-bold text-foreground data-text">{value}</p>
            {change && (
              <div className="flex items-center gap-2 mt-2">
                <Icon 
                  name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
                  size={16} 
                  className={getChangeColor()}
                />
                <span className={`text-sm font-medium ${getChangeColor()}`}>
                  {change}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityCard;